import React from "react";
import { tattoo } from "../../state";
import { HAIR_PRESETS, TOP_PRESETS, BOTTOM_PRESETS } from "../constants";

const sectionStyle = {
  padding: 10,
  borderRadius: 10,
  border: "1px solid rgba(255,255,255,0.08)",
  background: "rgba(255,255,255,0.03)",
  display: "grid",
  gap: 8,
};
const titleStyle = { fontSize: 11, letterSpacing: 0.8, opacity: 0.7, textTransform: "uppercase" };
const rowStyle = { display: "flex", gap: 6, flexWrap: "wrap" };
const chipBtn = (active) => ({
  width: 40, height: 40, borderRadius: 8,
  border: active ? "2px solid #fff" : "1px solid #333",
  background: "transparent", padding: 0,
  display: "grid", placeItems: "center", cursor: "pointer",
});
const chipDot = (hex) => ({
  width: 16, height: 16, borderRadius: 999, background: hex, display: "block",
});

export default function AppearanceSection({
  snap, opts, hairIsNone,
  appearanceOpen, setAppearanceOpen,
  hairMode, hairPreset, hairCustom,
  topMode, topPreset, topCustom,
  bottomMode, bottomPreset, bottomCustom,
  setHair, setTop, setBottom,
}) {
  return (
    <div className="section">
      <div
        className="tt-row"
        style={{
          alignItems: "center", gap: 8,
          paddingLeft: 12, paddingBottom: 8, paddingTop: 4, flexShrink: 0,
        }}
      >
        <span
          className="label"
          style={{ marginBottom: 0, textTransform: "uppercase", fontSize: 11, letterSpacing: 0.12, opacity: 0.85 }}
        >
          Hair & Clothes
        </span>
        <button
          type="button"
          className="mini-toggle"
          onClick={() => setAppearanceOpen((s) => !s)}
          style={{ width: 28, height: 28, borderRadius: 999, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, lineHeight: 1 }}
        >
          {appearanceOpen ? "–" : "+"}
        </button>
      </div>

      {appearanceOpen && (
        <div style={{ border: "1px solid #2b2b2b", borderRadius: 10, padding: 10, marginBottom: 10, background: "#0f0f0f" }}>
          <div style={{ display: "grid", gap: 10 }}>
            {/* HAIR */}
            <div style={sectionStyle}>
              <div style={titleStyle}>Hair</div>
              <select
                value={snap.appearance?.hair || "none"}
                onChange={(e) => { tattoo.appearance = { ...(tattoo.appearance || {}), hair: e.target.value }; }}
                className="btn"
                style={{ width: "100%", padding: "8px 10px" }}
              >
                {opts.hair.map((o) => <option key={o.key} value={o.key}>{o.label}</option>)}
              </select>
              <div style={{ fontSize: 12, opacity: hairIsNone ? 0.35 : 0.7, marginTop: 2 }}>Color</div>
              <div style={{ ...rowStyle, opacity: hairIsNone ? 0.35 : 1 }}>
                {HAIR_PRESETS.map((p) => (
                  <button
                    key={p.id} type="button"
                    onClick={() => { if (hairIsNone) return; setHair({ hairColorMode: "preset", hairColorPreset: p.id }); }}
                    title={hairIsNone ? "Select a hair style first" : p.label}
                    style={chipBtn(hairMode === "preset" && hairPreset === p.id)}
                    disabled={hairIsNone}
                  >
                    <span style={chipDot(p.hex)} />
                  </button>
                ))}
                <input
                  type="color" value={hairCustom}
                  onChange={(e) => { if (hairIsNone) return; setHair({ hairColorMode: "custom", hairColorCustom: e.target.value }); }}
                  disabled={hairIsNone}
                  title={hairIsNone ? "Select a hair style first" : "Custom hair color"}
                />
              </div>
            </div>

            {/* TOP */}
            <div style={sectionStyle}>
              <div style={titleStyle}>Top</div>
              <select
                value={snap.appearance?.top || "none"}
                onChange={(e) => { tattoo.appearance = { ...(tattoo.appearance || {}), top: e.target.value }; }}
                className="btn"
                style={{ width: "100%", padding: "8px 10px" }}
              >
                {opts.top.map((o) => <option key={o.key} value={o.key}>{o.label}</option>)}
              </select>
              <div style={{ fontSize: 12, opacity: 0.7, marginTop: 2 }}>Color</div>
              <div style={rowStyle}>
                {TOP_PRESETS.map((p) => (
                  <button
                    key={p.id} type="button"
                    onClick={() => setTop({ topColorMode: "preset", topColorPreset: p.id })}
                    title={p.label}
                    style={chipBtn(topMode === "preset" && topPreset === p.id)}
                  >
                    <span style={chipDot(p.hex)} />
                  </button>
                ))}
                <input
                  type="color" value={topCustom}
                  onChange={(e) => setTop({ topColorMode: "custom", topColorCustom: e.target.value })}
                  title="Custom top color"
                />
              </div>
            </div>

            {/* BOTTOM */}
            <div style={sectionStyle}>
              <div style={titleStyle}>Bottom</div>
              <select
                value={snap.appearance?.bottom || "none"}
                onChange={(e) => { tattoo.appearance = { ...(tattoo.appearance || {}), bottom: e.target.value }; }}
                className="btn"
                style={{ width: "100%", padding: "8px 10px" }}
              >
                {opts.bottom.map((o) => <option key={o.key} value={o.key}>{o.label}</option>)}
              </select>
              <div style={{ fontSize: 12, opacity: 0.7, marginTop: 2 }}>Color</div>
              <div style={rowStyle}>
                {BOTTOM_PRESETS.map((p) => (
                  <button
                    key={p.id} type="button"
                    onClick={() => setBottom({ bottomColorMode: "preset", bottomColorPreset: p.id })}
                    title={p.label}
                    style={chipBtn(bottomMode === "preset" && bottomPreset === p.id)}
                  >
                    <span style={chipDot(p.hex)} />
                  </button>
                ))}
                <input
                  type="color" value={bottomCustom}
                  onChange={(e) => setBottom({ bottomColorMode: "custom", bottomColorCustom: e.target.value })}
                  title="Custom bottom color"
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
